import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/asset-assessment/index'

export const Route = createFileRoute(
  '/asset-assessment/(deprecated_routes)/$siteID/{-$unitID}'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: params.siteID,
        [SEARCH_PARAM_UNIT_ID]: params.unitID,
      }),
      replace: true,
    })
  },
})
